import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import { formatPhoneNumber } from "@/utils.js";
import GPSColorStatus from "@/components/functionals/GPSColorStatus.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export const GetOfflineGPSs = async function (thiss) {
  let trackersCount = await thiss.$store.dispatch("navixy/getTotalGps");
  trackersCount;
  let NavUsersCount = await thiss.$store.dispatch("navixy/getTotalUsers");
  NavUsersCount;
  let trackers = thiss.$store.getters["navixy/getTrackers"];
  let NavUsers = thiss.$store.getters["navixy/getUserList"];

  let OfflineTrackers = trackers.filter(
    (t) => t.source.connection_status === "offline"
  );
  let customersWithContact;

  if (
    //thiss.currentUser.Roles.some((e) => e.Id === 37 || e.Id === 25)
    thiss.currentUser.PositionID == 52 ||
    thiss.currentUser.PositionID == 74 ||
    thiss.currentUser.PositionID == 110 ||
    thiss.currentUser.PositionID == 82 ||
    thiss.currentUser.PositionID == 16
  ) {
    await thiss.$http
      .get("/api/customers/GetCustomersWithContacts", {
        timeout: 3 * 60 * 1000,
        params: {
          Page: 1,
          Limit: 1000000,
          CompanyId: thiss.currentCompany,
          SalesPersonCode: null,
          Name: null,
          CustomerService: null,
          Contract: null,
          AccountReceivable: null,
          clasificaction: null,
          ClientType: null
        }
      })
      .then((response) => {
        //console.log("CustomerList: ", response);
        customersWithContact = response.data.Items;
        // console.log("klk data gps",OfflineTrackers)
      });
    let actualDate = new Date();
    OfflineTrackers.forEach((ot) => {
      ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
      ot.client = customersWithContact.filter(
        (cust) => cust.ClientCode === ot.user.post_region
      )[0];
      ot.daysOffline = Math.round(
        Math.abs(
          new Date(ot.last_connection).getTime() - actualDate.getTime()
        ) /
          (1000 * 3600 * 24)
      );
    });

    let FilteredOfflineTrackers = OfflineTrackers.filter(
      (offtrack) => offtrack.daysOffline > 0 //&& offtrack.daysOffline <= 30
    );
    /*
    console.log(
      "trackers GPSs: ",
      OfflineTrackers.length,
      "\n Trackers: ",
      OfflineTrackers,
      "\n Users: ",
      NavUsers
    );
    */

    return FilteredOfflineTrackers;
  } else {
    return [];
  }
};

export const OfflineGPSsColumns = [
  {
    prop: "label",
    label: "Equipo",
    "min-width": 300,
    sortable: true,
    fixed: true
  },
  {
    prop: "client.Name",
    label: "Cliente",
    "min-width": 300,
    sortable: true,
    fixed: true
  },
  {
    prop: "source.connection_status",
    label: "Estado",
    align: "center",
    "min-width": 100,
    formatter: GPSColorStatus
  },
  {
    prop: "last_connection",
    label: "Fecha ultima conexion",
    "min-width": 190,
    align: "center",
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "daysOffline",
    label: "Dias fuera de Linea",
    "min-width": 170,
    align: "center",
    sortable: true,
    formatter: (row) => row.daysOffline + " Dias"
  },
  {
    prop: "client.PhoneNumber",
    label: "Telefono del Contacto",
    "min-width": 210,
    formatter: (row) => formatPhoneNumber(row.client.PhoneNumber)
  },
  {
    prop: "client.Email",
    label: "Email del Contacto",
    sortable: true,
    "min-width": 250
  },
  {
    prop: "client.CustomerService",
    label: "Servicio al Cliente",
    sortable: true,
    "min-width": 210,
    formatter: ImagePerson,
    attrs: {
      imgKey: "client.CustomerServiceImage"
    }
  },
  {
    prop: "client.SalesPersonName",
    label: "Vendedor",
    sortable: true,
    "min-width": 210,
    formatter: ImagePerson,
    attrs: {
      imgKey: "client.SalesPersonPhoto"
    }
  },
  {
    prop: "client.AccountReceivable",
    label: "Cuenta por Cobrar",
    sortable: true,
    "min-width": 170,
    formatter: ImagePerson
    /*
    attrs: {
      imgKey: "client.CxC"
    }
    */
  }
];

export const OfflineGPSsActions = [
  {
    label: "Crear solicitud de soporte",
    icon: "",
    command: "create_support_request"
  },
  {
    label: "Crar una interaccion al cleinte",
    icon: "",
    command: "create_client_iteration"
  }
];
